module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCA2IDgiIGZpbGw9Im5vbmUiPgo8cGF0aCBkPSJNNS4yNSAzLjU2Njk5QzUuNTgzMzMgMy43NTk0NCA1LjU4MzMzIDQuMjQwNTYgNS4yNSA0LjQzMzAxTDAuNzQ5OTk5IDcuMDMxMDlDMC40MTY2NjYgNy4yMjM1NCAtMy4wNTIzNmUtMDcgNi45ODI5OCAtMi44ODQxMWUtMDcgNi41OTgwOEwtNi4xMjhlLTA4IDEuNDAxOTJDLTQuNDQ1NTVlLTA4IDEuMDE3MDIgMC40MTY2NjYgMC43NzY0NjEgMC43NSAwLjk2ODkxMUw1LjI1IDMuNTY2OTlaIiBmaWxsPSIjRDlEOUQ5Ii8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/views/My/Base/components/ListMenus/images/icon-triangle.svg
// module id = P25j
// module chunks = 0